import DashboardHeader from "./DashboardHeader";
import VoiceRecordingCard from "./VoiceRecordingCard";
import ImageCaptureCard from "./ImageCaptureCard";

const Dashboard = () => {
  return (
    <div className="container mx-auto py-10 px-4 bg-background">
      <DashboardHeader />
      
      <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
        <VoiceRecordingCard />
        <ImageCaptureCard />
      </div>
    </div>
  );
};

export default Dashboard;
